// ============================================================
//  SHOPPABLE VIDEO JS — autônomo, sem depender de PopupBase
//  Usa tingle.modal diretamente (já carregado pelo tema)
// ============================================================

(function () {
  // Aguarda o DOM estar pronto
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // ── 1. Lazy-load dos vídeos do thumbnail ─────────────────
    const lazyObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        entry.target.querySelectorAll('video[data-src]').forEach((v) => {
          v.src = v.dataset.src;
          v.removeAttribute('data-src');
        });
      });
    }, { rootMargin: '0px 0px 300px 0px' });

    document.querySelectorAll('shopable-video').forEach((el) => {
      lazyObserver.observe(el);
    });

    // ── 2. Click em cada slide abre o popup ──────────────────
    document.querySelectorAll('shopable-video').forEach((slide) => {
      slide.addEventListener('click', function (e) {
        // Não abre popup se clicou dentro do sv-card (card do thumbnail)
        if (e.target.closest('.sv-card')) return;

        const popupWrapper = slide.querySelector('.video-item__popup');
        if (!popupWrapper) return;

        // Clona o wrap inteiro (vídeo + card + botões)
        const storyEl = popupWrapper.querySelector('.sv-story-wrap');
        if (!storyEl) return;

        openStoryModal(storyEl);
      });
    });
  });

  // ── Abre modal com o story ────────────────────────────────
  function openStoryModal(storyEl) {
    // Clona para não mexer no DOM original
    const clone = storyEl.cloneNode(true);

    // Cria o modal tingle (já disponível globalmente no tema)
    const TingleModal = (window.tingle && window.tingle.modal)
      ? window.tingle.modal
      : (typeof tingle !== 'undefined' ? tingle.modal : null);

    if (!TingleModal) {
      console.warn('[ShopableVideo] tingle não encontrado.');
      return;
    }

    let vid = null;

    const modal = new TingleModal({
      cssClass: ['shopable-video', 'sv-modal'],
      closeMethods: ['overlay', 'escape', 'button'],
      closeLabel: 'Fechar',
      onOpen: function () {
        vid = modal.modal.querySelector('.sv-story-video');
        if (vid && vid.tagName === 'VIDEO') {
          vid.currentTime = 0;
          vid.muted = true;
          vid.play().catch(() => {});
        }
      },
      onClose: function () {
        if (vid && vid.tagName === 'VIDEO') vid.pause();
        setTimeout(() => modal.destroy(), 300);
      }
    });

    modal.setContent(clone.outerHTML);
    modal.open();
  }

})();
